import React from 'react';
import { CollapsibleGroup } from '@fiverr-private/disclosure';
import type { FAQItem } from '../types';
import { FAQCollapsibleItem } from './FAQCollapsibleItem';

type FAQContentProps = Readonly<{
    items: FAQItem[];
}>;

export const FAQContent = ({ items }: FAQContentProps) => (
    <CollapsibleGroup>
        {items.map((item) => (
            <FAQCollapsibleItem key={item.question} {...item} />
        ))}
    </CollapsibleGroup>
);
